// extracted by mini-css-extract-plugin
module.exports = {"grid":"archive-module--grid--2w3Yr","item":"archive-module--item--9ok3k","titleCard":"archive-module--titleCard--1spo4"};